import { ReportData } from '../types/reportTypes';

// Sample data for the marketing report
export const sampleData: ReportData = {
  kpis: {
    adSpend: 40309.27, // Should be using March adSpend sum with Angi = 2530.00
    totalSales: 258205.85,
    grossProfit: 112535.95,
    salesCommissions: 10941.98, 
    managerFees: 2582.06,
    companyOH: 40021.91,
    netProfit: 18680.73, // Should be recalculated with correct adSpend
    netProfitPercent: 0.0723,
    grossProfitPercent: 0.4217
  },
  
  // Ad spend by lead source
  adSpendBySource: [
    { source: "HomeBuddy", spend: 8759.00 },
    { source: "Thumbtack", spend: 6900.00 },
    { source: "Web to Lead Form", spend: 5595.00 },
    { source: "Google Organic", spend: 3500.00 },
    { source: "Facebook / Meta Ads", spend: 3321.86 },
    { source: "Networx", spend: 3000.00 },
    { source: "Google AdWords", spend: 2915.53 },
    { source: "Yelp", spend: 2801.48 },
    { source: "Angi", spend: 2530.00 },
    { source: "Google LSA", spend: 390.00 },
    { source: "BBB", spend: 300.00 },
    { source: "Porch", spend: 296.40 },
    { source: "Guild Quality", spend: 0.00 },
    { source: "Contractor Appointment", spend: 0.00 },
    { source: "Lead2Performance", spend: 0.00 },
    { source: "Spring Connect", spend: 0.00 }
  ],
  
  // Sales by lead source
  salesBySource: [
    { source: "Yelp", totalSales: 47364.00, count: 4, grossProfit: 20610.61 },
    { source: "Google Organic Search", totalSales: 44040.41, count: 4, grossProfit: 19785.02 },
    { source: "Homebuddy", totalSales: 33286.35, count: 3, grossProfit: 14526.82 },
    { source: "Thumbtack", totalSales: 32718.90, count: 3, grossProfit: 13442.44 },
    { source: "Web to Lead Form", totalSales: 31600.19, count: 3, grossProfit: 13487.81 },
    { source: "Facebook / Meta Ads", totalSales: 26921.00, count: 1, grossProfit: 10768.40 },
    { source: "Referral - Word of mouth", totalSales: 18734.00, count: 1, grossProfit: 7976.94 },
    { source: "Angi", totalSales: 13000.00, count: 1, grossProfit: 6997.90 },
    { source: "Networx", totalSales: 6041.00, count: 1, grossProfit: 2416.40 },
    { source: "Previous Customer", totalSales: 4500.00, count: 1, grossProfit: 2523.60 }
  ],
  
  // Sales by trade
  salesByTrade: [
    { trade: "Roofing", totalSales: 135635.81, count: 12, grossProfit: 65500.00 },
    { trade: "Windows & Doors", totalSales: 91296.85, count: 8, grossProfit: 43500.00 },
    { trade: "Siding", totalSales: 16650.00, count: 1, grossProfit: 6794.87 },
    { trade: "Gutters", totalSales: 14623.19, count: 1, grossProfit: 5885.83 }
  ],
  
  // Individual job data
  jobData: [
    // Roofing Jobs
    {
      jobInfo: "251: David & Gail Cantor",
      leadSource: "Referral - Word of mouth",
      trade: "Roofing",
      contractTotal: 18734.00,
      grossMarginPct: 0.4258,
      grossProfit: 7976.94,
      salesCommission: 749.36,
      salesManagerFee: 187.34,
      companyOH: 2903.77,
      netProfit: 4136.47
    },
    {
      jobInfo: "E-293: Saundra & Jeff Bishop",
      leadSource: "Google Organic Search",
      trade: "Roofing",
      contractTotal: 10169.41,
      grossMarginPct: 0.4357,
      grossProfit: 4430.81,
      salesCommission: 406.78,
      salesManagerFee: 101.69,
      companyOH: 1576.26,
      netProfit: 2346.08
    },
    {
      jobInfo: "E-277: Kimberly Hill",
      leadSource: "Homebuddy",
      trade: "Roofing",
      contractTotal: 10338.40,
      grossMarginPct: 0.4846,
      grossProfit: 5009.99,
      salesCommission: 413.54,
      salesManagerFee: 103.38,
      companyOH: 1602.45,
      netProfit: 2890.62
    },
    {
      jobInfo: "E-295: Eric & Allison Boiter",
      leadSource: "Yelp",
      trade: "Roofing",
      contractTotal: 7472.00,
      grossMarginPct: 0.3645,
      grossProfit: 2723.54,
      salesCommission: 0.00,
      salesManagerFee: 74.72,
      companyOH: 1158.16,
      netProfit: 1490.66
    },
    {
      jobInfo: "258: Karoun & David Demirjian",
      leadSource: "Previous Customer",
      trade: "Roofing",
      contractTotal: 4500.00,
      grossMarginPct: 0.5608,
      grossProfit: 2523.60,
      salesCommission: 315.00,
      salesManagerFee: 45.00,
      companyOH: 697.50,
      netProfit: 1466.10
    },
    {
      jobInfo: "257: Fredrick Mullen",
      leadSource: "Web to Lead Form",
      trade: "Roofing",
      contractTotal: 8990.00,
      grossMarginPct: 0.4666,
      grossProfit: 4194.73,
      salesCommission: 359.60,
      salesManagerFee: 89.90,
      companyOH: 1393.45,
      netProfit: 2351.78
    },
    {
      jobInfo: "259: Quinn & Jillian Gooden",
      leadSource: "Google Organic Search",
      trade: "Roofing",
      contractTotal: 12921.00,
      grossMarginPct: 0.5004,
      grossProfit: 6465.67,
      salesCommission: 904.47,
      salesManagerFee: 129.21,
      companyOH: 2002.76,
      netProfit: 3429.23
    },
    {
      jobInfo: "E-279: Kevin & Patricia Weinkauf",
      leadSource: "Web to Lead Form",
      trade: "Roofing",
      contractTotal: 7987.00,
      grossMarginPct: 0.4266,
      grossProfit: 3407.25,
      salesCommission: 319.48,
      salesManagerFee: 79.87,
      companyOH: 1237.99,
      netProfit: 1769.91
    },
    {
      jobInfo: "E-268: Charlie & Vernell Bellamy",
      leadSource: "Homebuddy",
      trade: "Roofing",
      contractTotal: 14632.00,
      grossMarginPct: 0.4187,
      grossProfit: 6126.42,
      salesCommission: 585.28,
      salesManagerFee: 146.32,
      companyOH: 2267.96,
      netProfit: 3126.86
    },
    {
      jobInfo: "E-276: Joanna Wald",
      leadSource: "Yelp",
      trade: "Roofing",
      contractTotal: 13811.00,
      grossMarginPct: 0.4034,
      grossProfit: 5571.36,
      salesCommission: 552.44,
      salesManagerFee: 138.11,
      companyOH: 2140.71,
      netProfit: 2740.10
    },
    {
      jobInfo: "260: David & Laura Jalette",
      leadSource: "Yelp",
      trade: "Roofing",
      contractTotal: 10621.00,
      grossMarginPct: 0.4878,
      grossProfit: 5180.92,
      salesCommission: 424.84,
      salesManagerFee: 106.21,
      companyOH: 1646.26,
      netProfit: 3003.61
    },
    {
      jobInfo: "256: Beverly Stone",
      leadSource: "Yelp",
      trade: "Roofing",
      contractTotal: 15460.00,
      grossMarginPct: 0.4615,
      grossProfit: 7134.79,
      salesCommission: 618.40,
      salesManagerFee: 154.60,
      companyOH: 2396.30,
      netProfit: 3965.49
    },
    
    // Windows & Doors Jobs
    {
      jobInfo: "E-272: Mark & Christina Newcomer",
      leadSource: "Homebuddy",
      trade: "Windows & Doors",
      contractTotal: 8315.95,
      grossMarginPct: 0.4077,
      grossProfit: 3390.41,
      salesCommission: 332.64,
      salesManagerFee: 83.16,
      companyOH: 1288.97,
      netProfit: 1685.64
    },
    {
      jobInfo: "E-273: Tara & Alford Bell",
      leadSource: "Thumbtack",
      trade: "Windows & Doors",
      contractTotal: 19700.00,
      grossMarginPct: 0.4124,
      grossProfit: 8124.28,
      salesCommission: 788.00,
      salesManagerFee: 197.00,
      companyOH: 3053.50,
      netProfit: 4085.78
    },
    {
      jobInfo: "E-269: Nathan Whitaker",
      leadSource: "Thumbtack",
      trade: "Windows & Doors",
      contractTotal: 3026.90,
      grossMarginPct: 0.4098,
      grossProfit: 1240.42,
      salesCommission: 121.08,
      salesManagerFee: 30.27,
      companyOH: 469.17,
      netProfit: 619.90
    },
    {
      jobInfo: "E-270: Brenda Jackson",
      leadSource: "Thumbtack",
      trade: "Windows & Doors",
      contractTotal: 9992.00,
      grossMarginPct: 0.4081,
      grossProfit: 4077.74,
      salesCommission: 399.68,
      salesManagerFee: 99.92,
      companyOH: 1548.76,
      netProfit: 2029.38
    },
    {
      jobInfo: "Sean Quinn",
      leadSource: "Google Organic Search",
      trade: "Windows & Doors",
      contractTotal: 4300.00,
      grossMarginPct: 0.4869,
      grossProfit: 2093.67,
      salesCommission: 172.00,
      salesManagerFee: 43.00,
      companyOH: 666.50,
      netProfit: 1212.17
    },
    {
      jobInfo: "Pat Kaufman",
      leadSource: "Networx",
      trade: "Windows & Doors",
      contractTotal: 6041.00,
      grossMarginPct: 0.4000,
      grossProfit: 2416.40,
      salesCommission: 241.64,
      salesManagerFee: 60.41,
      companyOH: 936.36,
      netProfit: 1177.99
    },
    {
      jobInfo: "Tyler & Elea Fogarty",
      leadSource: "Angi",
      trade: "Windows & Doors",
      contractTotal: 13000.00,
      grossMarginPct: 0.5383,
      grossProfit: 6997.90,
      salesCommission: 910.00,
      salesManagerFee: 130.00,
      companyOH: 2015.00,
      netProfit: 3942.90
    },
    {
      jobInfo: "William & Tyla Liggins",
      leadSource: "Facebook / Meta Ads",
      trade: "Windows & Doors",
      contractTotal: 26921.00,
      grossMarginPct: 0.4000,
      grossProfit: 10768.40,
      salesCommission: 1076.84,
      salesManagerFee: 269.21,
      companyOH: 4172.76,
      netProfit: 5249.59
    },
    
    // Other Jobs
    {
      jobInfo: "243: John & Zirah Albano",
      leadSource: "Web to Lead Form",
      trade: "Gutters",
      contractTotal: 14623.19,
      grossMarginPct: 0.4025,
      grossProfit: 5885.83,
      salesCommission: 584.93,
      salesManagerFee: 146.23,
      companyOH: 2266.59,
      netProfit: 2888.08
    },
    {
      jobInfo: "Evan Miles",
      leadSource: "Google Organic Search",
      trade: "Siding",
      contractTotal: 16650.00,
      grossMarginPct: 0.4081,
      grossProfit: 6794.87,
      salesCommission: 666.00,
      salesManagerFee: 166.50,
      companyOH: 2580.75,
      netProfit: 3381.62
    }
  ],
  period: {
    month: 3, // March
    year: 2025
  }
};